import './styles.scss';
import aboutImage from '../../assets/about-image-e.JPG'

function About() {

    return (
        <div id='about-section' className="container-about">
            <div className='about-image'>
                <img src={aboutImage} alt='Dra. Lais' />
                <a className='about-instagram' href='https://www.instagram.com/laismuhana/' target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i>@laismuhana</a>
            </div>
            <div className='about-text'>
                <h1>Sobre a Dra. Lais</h1>
                <p>A Dra. Lais Muhana é cirurgiã vascular, especializada no tratamento de varizes e vasinhos, com foco em acolhimento, escuta e segurança. Une conhecimento técnico à sensibilidade de quem entende que cada paciente tem sua própria história.</p>
                <p>  Com mais de 10 anos de dedicação à medicina, formada em duas residências médicas, Cirurgia Geral e Cirurgia Vascular, está em constante atualização e atua com ética, empatia e olhar humanizado.</p>
                <p> Acredita que cuidar da circulação é também cuidar da autoestima, do movimento e da liberdade de viver sem dor ou desconforto.
                </p>

            </div>

        </div>
    );
}

export default About;
